import ModalLayout from 'components/ModalLayout';
import Text from 'components/Text/Text';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from 'modules/CustomersAndRestaurants/Customers/CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import {
	CreateScheduleContext,
	ICreateScheduleContext,
} from './createScheduleModalContext/createScheduleModalState/createScheduleModalContext';
import moment from 'moment';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import PushTypeSelect from './components/PushTypeSelect';
import ScheduleField from './components/ScheduleField';
import RestaurantsMultipleSelect from './components/RestaurantsMultipleSelect/RestaurantsMultipleSelect';
import BtnBlock from './components/BtnBlock';
import ModalWindows from './components/ModalWindows';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './CreateScheduleModal.module.scss';

interface ICreateScheduleModal {
	isVisible: boolean;
	onFailureEvent: () => void;
}

const CreateScheduleModal: React.FC<ICreateScheduleModal> = ({ isVisible, onFailureEvent }) => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);
	const {
		setDataForSubmit,
		changeTypeOfModalWindow,
		setPushType,
		changeSchedule,
		resetFields,
		setFetchedRestaurants,
		setIDsRestaurant,
		pushType,
		schedule,
		fetchedRestaurants,
		IDsSelectedRestaurant,
	} = useContext<ICreateScheduleContext>(CreateScheduleContext);

	const [form] = Form.useForm();

	useEffect(() => {
		if (isVisible) {
			form.setFieldsValue({ pushType });
			form.setFieldsValue({ schedule: schedule ? moment(schedule) : '' });
			form.setFieldsValue({ IDsSelectedRestaurant });
		}
	}, [pushType, schedule, IDsSelectedRestaurant, isVisible]);

	const submit = () => {
		customerForFullInfo &&
			setDataForSubmit({
				customerId: customerForFullInfo.id,
				type: pushType,
				scheduledDate: schedule,
				restaurantIds: IDsSelectedRestaurant,
			});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleCloseModal = () => {
		resetFields();
		onFailureEvent();
	};

	return (
		<ModalLayout isVisible={isVisible} setIsShowModal={handleCloseModal} data-test="CreateScheduleModal">
			<Text
				className={style.title}
				translationNameSpace="form"
				translationKey="createScheduledPushHeading"
				size="xxl"
				weight="bold"
			/>
			<Form
				className={style.form}
				form={form}
				name="createSchedule"
				onFinish={submit}
				onKeyPress={preventDefaultForEnterKey}
				layout="vertical">
				<div className={style.wrapper}>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="pushHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<div className={style.row}>
							<PushTypeSelect setPushType={setPushType} />
							<ScheduleField schedule={schedule} changeSchedule={changeSchedule} />
						</div>
					</div>
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="restaurantsHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<RestaurantsMultipleSelect
							setFetchedRestaurants={setFetchedRestaurants}
							setIDsRestaurant={setIDsRestaurant}
							fetchedRestaurants={fetchedRestaurants}
							IDsSelectedRestaurant={IDsSelectedRestaurant}
							customerId={customerForFullInfo?.id || ''}
						/>
					</div>
					<div className={style.buttonBlock}>
						<BtnBlock />
					</div>
				</div>
			</Form>
			<ModalWindows />
		</ModalLayout>
	);
};

export default React.memo(CreateScheduleModal);
